var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElDialog',{attrs:{"title":_vm.modalTitle,"visible":_vm.value,"width":"40%","append-to-body":true},on:{"close":_vm.resetAndClose}},[_c('EditPriceOfferForm',{attrs:{"loading":_vm.loading,"reset-controller":_vm.resetController},on:{"cancel":_vm.resetAndClose,"save":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }